import React, { Component } from 'react';

class FeelInMorning extends Component {
	render() {
		return (
			<section className="assessment morning_feel">
				<div className="container-fluid">
					<h1 className="assessment__heading">How does your skin feel in the morning?</h1>
					<div className="morning_feel--field">
						<form>
							<table>
								<tbody>
									<tr>
										<td></td>
										<td>Dry</td>
										<td>Normal</td>
										<td>Oily</td>
									</tr>
									<tr>
										<th>Cheeks</th>
										<td>
											<div className="radio">
												<input id="cheek-dry" type="radio" name="cheeks" />
												<label for="cheek-dry" className="radio-label"></label>
											</div>
										</td>
										<td>
											<div className="radio">
												<input id="cheek-normal" type="radio" name="cheeks" />
												<label for="cheek-normal" className="radio-label"></label>
											</div>
										</td>
										<td>
											<div className="radio">
												<input id="cheek-oily" type="radio" name="cheeks" />
												<label for="cheek-oily" className="radio-label"></label>
											</div>
										</td>
									</tr>
									<tr>
										<th>T zone <img title="(Forehead, nose & chin)" src="images/assessment/ques-icon.svg" alt="" /></th>
										<td>
											<div className="radio">
												<input id="tzone-dry" type="radio" name="tzone" />
												<label for="tzone-dry" className="radio-label"></label>
											</div>
										</td>
										<td>
											<div className="radio">
												<input id="tzone-normal" type="radio" name="tzone" />
												<label for="tzone-normal" className="radio-label"></label>
											</div>
										</td>
										<td>
											<div className="radio">
												<input id="tzone-oily" type="radio" name="tzone" />
												<label for="tzone-oily" className="radio-label"></label>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</form>
						<span className="info"><img src="images/assessment/info.svg" alt="" /> How to check</span>
					</div>
				</div>
				<div className="howtocheck__video d-none">

				</div>
			</section>
			);
	}
}


export default FeelInMorning;